import { render, staticRenderFns } from "./LicitacaoAtualizacaoDadosGerais.vue?vue&type=template&id=e2abb0fe"
import script from "./LicitacaoAtualizacaoDadosGerais.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoDadosGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports